import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Download } from '@tds/core-interactive-icon';
import { Document } from '@tds/core-decorative-icon';
import Button from '@tds/core-button';

import request, { apiHost } from '../../../utils/request';
import Modal from '../../shared/modal';
import { customStyles, Input, Tag, RemoveTagButton, Spacer } from './styles';

const SendQuoteToCustomer = ({
  isModalVisible,
  setIsModalVisible,
  orderId: id
}) => {
  const [emails, setEmails] = useState([]);
  const [submissionError, setSubmissionError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = event => {
    setInputValue(event.target.value);
  };

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  const handleKeyDown = event => {
    if (event.key === 'Enter' && inputValue !== '') {
      if (validateEmail(inputValue)) {
        setEmails([...emails, inputValue]);
        setInputValue('');
        setEmailError('');
        setSubmissionError('');
      } else {
        setEmailError('Invalid Email, enter a valid email and hit Enter');
      }
      event.preventDefault();
    } else if (event.key === 'Backspace' && inputValue === '') {
      setEmails(emails.slice(0, -1));
    }
  };

  const handleRemoveTag = index => {
    setEmails(emails.filter((_, i) => i !== index));
  };

  const onFileDownload = () => {
    const url = `${apiHost}/orders/${id}/sevenx-quote-pdf`;
    window.open(url);
  };

  const onSend = async () => {
    if (!emails.length) {
      setSubmissionError('No email recipient added');
      if (inputValue.length) {
        setEmailError('Press enter to add this email');
      }
      return;
    }
    setSubmissionError('');
    try {
      await request.post(`/orders/${id}/send-quote-pdf`, {
        to: emails.join(',')
      });
      setIsModalVisible();
    } catch (e) {
      setSubmissionError(e);
    }
  };

  return (
    <Modal
      open={isModalVisible}
      setOpen={setIsModalVisible}
      customStyles={customStyles}
      header="Send Quote to Customer"
    >
      {emails.map((email, index) => (
        <Tag key={email}>
          {email}
          <RemoveTagButton onClick={() => handleRemoveTag(index)}>
            x
          </RemoveTagButton>
        </Tag>
      ))}
      <Input
        type="text"
        placeholder="To (Type email and press enter)"
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
      />
      {emailError && (
        <div style={{ fontSize: 12, color: 'red' }}>{emailError}</div>
      )}
      <Spacer />
      <li
        className="list-group-item"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <div style={{ display: 'flex', backgroundColor: 'transparent' }}>
          <Document a11yText="Document" />
          Quote PDF
        </div>
        <div style={{ backgroundColor: 'transparent' }}>
          <Download onClick={onFileDownload} a11yText="Download" />
        </div>
      </li>
      <Spacer />
      {submissionError && (
        <div style={{ fontSize: 14, color: 'red', marginTop: -4 }}>
          {submissionError}
        </div>
      )}
      <Button onClick={onSend}>Send</Button>
    </Modal>
  );
};

SendQuoteToCustomer.propTypes = {
  isModalVisible: PropTypes.bool.isRequired,
  setIsModalVisible: PropTypes.func.isRequired,
  orderId: PropTypes.number.isRequired
};

export default SendQuoteToCustomer;
